import { useCallback, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { RegisterContext } from "@/components/landing/RegisterContext";
import { TopStrip, StickyBar } from "@/components/landing/StickyBar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Learning } from "@/components/landing/Learning";
import { WhySection } from "@/components/landing/WhySection";
import { Parts } from "@/components/landing/Parts";
import { Mentor } from "@/components/landing/Mentor";
import { Expect } from "@/components/landing/Expect";
import { FinalCta, Footer } from "@/components/landing/FinalCta";
import { RegisterModal } from "@/components/landing/RegisterModal";

export default function Landing() {
  const [open, setOpen] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  useEffect(() => {
    if (open) lenisRef.current?.stop(); else lenisRef.current?.start();
  }, [open]);

  const openForm = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <RegisterContext.Provider value={{ openForm }}>
      <main className="min-h-screen bg-white overflow-x-clip" data-testid="landing-page">
        <TopStrip />
        <Hero />
        <Marquee />
        <Learning />
        <WhySection />
        <Parts />
        <Mentor />
        <Expect />
        <FinalCta />
        <Footer />
      </main>
      <StickyBar />
      <RegisterModal open={open} onClose={close} />
    </RegisterContext.Provider>
  );
}
